import { createSlice } from '@reduxjs/toolkit';
import { FilterMatchMode } from 'primereact/api';

import {
  countOfOrderTableFilters,
  TenantReportSlice,
  TenantReportSliceFilter,
} from '../../components/Admin/TennantBilling/interface/tenantBilling.interface';

const INITIAL_FILTERS: countOfOrderTableFilters = {
  client_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
  year: { value: null, matchMode: FilterMatchMode.CONTAINS },
  month: { value: null, matchMode: FilterMatchMode.CONTAINS },
};

const tenantReportSlice = createSlice({
  name: 'tenantReport',
  initialState: INITIAL_FILTERS,
  reducers: {
    updateTenantReportFilter(state, { payload }: TenantReportSlice) {
      const { field, value, matchMode } = payload;
      state[field] = { value, matchMode };
    },
    setAllTenantReportFilters(_, { payload }: TenantReportSliceFilter) {
      return payload;
    },
    clearTenantReportFilters() {
      return INITIAL_FILTERS;
    },
  },
});

export const {
  updateTenantReportFilter,
  setAllTenantReportFilters,
  clearTenantReportFilters,
} = tenantReportSlice.actions;

export const tenantReportReducer = tenantReportSlice.reducer;
